<template>
    <div class="content-wrap">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'Blank',
        data: () => {
            return {}
        }
    }
</script>

